import React from 'react';
import { Search, Bell, User, Menu } from 'lucide-react';
interface HeaderProps {
  toggleSidebar: () => void;
}
const Header: React.FC<HeaderProps> = ({
  toggleSidebar
}) => {
  return <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 h-16 flex items-center justify-between px-4 md:px-6" data-id="element-71">
      <div className="flex items-center" data-id="element-72">
        <button onClick={toggleSidebar} className="mr-4 md:hidden text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200" data-id="element-73">
          <Menu size={24} data-id="element-74" />
        </button>
        <div className="relative" data-id="element-75">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-76">
            <Search size={18} className="text-gray-400" data-id="element-77" />
          </div>
          <input type="text" placeholder="Search..." className="pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 w-64 md:w-80" data-id="element-78" />
        </div>
      </div>
      <div className="flex items-center" data-id="element-79">
        <button className="relative p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200" data-id="element-80">
          <Bell size={20} data-id="element-81" />
          <span className="absolute top-1 right-1 h-4 w-4 bg-red-500 rounded-full flex items-center justify-center text-xs text-white" data-id="element-82">
            3
          </span>
        </button>
        <div className="ml-4 flex items-center" data-id="element-83">
          <div className="h-8 w-8 rounded-full bg-blue-600 flex items-center justify-center text-white" data-id="element-84">
            <User size={18} data-id="element-85" />
          </div>
          <span className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-200 hidden md:block" data-id="element-86">
            Admin User
          </span>
        </div>
      </div>
    </header>;
};
export default Header;